/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RocketWarehouseResVo } from './RocketWarehouseResVo';
import {
    RocketWarehouseResVoFromJSON,
    RocketWarehouseResVoFromJSONTyped,
    RocketWarehouseResVoToJSON,
    RocketWarehouseResVoToJSONTyped,
} from './RocketWarehouseResVo';

/**
 * 
 * @export
 * @interface PageDataRocketWarehouseResVo
 */
export interface PageDataRocketWarehouseResVo {
    /**
     * 当前页
     * @type {number}
     * @memberof PageDataRocketWarehouseResVo
     */
    currentPage?: number;
    /**
     * 总页数
     * @type {number}
     * @memberof PageDataRocketWarehouseResVo
     */
    totalPage?: number;
    /**
     * 总记录数
     * @type {number}
     * @memberof PageDataRocketWarehouseResVo
     */
    totalRecord?: number;
    /**
     * 列表内容
     * @type {Array<RocketWarehouseResVo>}
     * @memberof PageDataRocketWarehouseResVo
     */
    records?: Array<RocketWarehouseResVo>;
}

/**
 * Check if a given object implements the PageDataRocketWarehouseResVo interface.
 */
export function instanceOfPageDataRocketWarehouseResVo(value: object): value is PageDataRocketWarehouseResVo {
    return true;
}

export function PageDataRocketWarehouseResVoFromJSON(json: any): PageDataRocketWarehouseResVo {
    return PageDataRocketWarehouseResVoFromJSONTyped(json, false);
}

export function PageDataRocketWarehouseResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageDataRocketWarehouseResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'totalPage': json['totalPage'] == null ? undefined : json['totalPage'],
        'totalRecord': json['totalRecord'] == null ? undefined : json['totalRecord'],
        'records': json['records'] == null ? undefined : ((json['records'] as Array<any>).map(RocketWarehouseResVoFromJSON)),
    };
}

export function PageDataRocketWarehouseResVoToJSON(json: any): PageDataRocketWarehouseResVo {
    return PageDataRocketWarehouseResVoToJSONTyped(json, false);
}

export function PageDataRocketWarehouseResVoToJSONTyped(value?: PageDataRocketWarehouseResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currentPage': value['currentPage'],
        'totalPage': value['totalPage'],
        'totalRecord': value['totalRecord'],
        'records': value['records'] == null ? undefined : ((value['records'] as Array<any>).map(RocketWarehouseResVoToJSON)),
    };
}

